import { addDays } from "date-fns/addDays";
import {
  FormattedWorkTimeBankSetting,
  WorkTimeBankSetting,
} from "../../../employment/employmentApi";
import { EditEntry } from "../../entriesAPI";

export const shouldShowSupplementDescription = (code: string) => {
  const normalizedCode = code.toLowerCase();

  return (
    normalizedCode.includes("paivaraha") ||
    normalizedCode.includes("päiväraha") ||
    normalizedCode.includes("kilometrikorvaus")
  );
};

export const shouldEnforceNegativeValue = (code?: string) => {
  const normalizedCode = code?.toLowerCase() || "";

  return (
    normalizedCode === "asuntovuokra_ei_laskutukseen" ||
    normalizedCode === "ateriavahennys_ei_laskutukseen"
  );
};

export const formatSettings = (
  settings: WorkTimeBankSetting[],
  assignmentEnd?: number,
): FormattedWorkTimeBankSetting[] => {
  return settings.map((setting, i) => {
    const nextItem = settings[i + 1];
    if (!nextItem) {
      return {
        ...setting,
        from: new Date(setting.from),
        to: assignmentEnd ? new Date(assignmentEnd) : null,
        mode: setting.mode,
      };
    }
    return {
      ...setting,
      from: new Date(setting.from),
      to: addDays(new Date(nextItem.from), -1),
      mode: setting.mode,
    };
  });
};

export const findSettingForEntryDate = (
  formattedSettings: FormattedWorkTimeBankSetting[],
  entry: EditEntry | null,
) => {
  return formattedSettings.find((setting) => {
    if (!entry) return false;
    // Note: if setting end date is null, it is the last setting (for indeterminate length assignment)
    if (!setting.to) {
      // Setting end date needs to determined for indeterminate length assignment.
      // If entry is not in the future, use current date as setting end date (works because the setting is valid indeterminately from x date).
      // If entry is in the future, use entry start as setting end date.
      const currentDate = new Date().getTime();
      const settingEndDate =
        entry.start <= currentDate ? currentDate : entry.start;
      return (
        entry.start >= setting.from.getTime() && entry.start <= settingEndDate
      );
    }
    return (
      entry.start >= setting.from.getTime() &&
      entry.start <= setting.to.getTime()
    );
  });
};
